import { combineReducers, createStore } from 'redux'
import commonReducer from './common'

const rootReducer = combineReducers({
  common: commonReducer,
})

const store = () => {
  return createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f)
}

export default store
